import React from "react";
import Preview from "../Preview/Preview";
import productData from "../../../data/products";
import communityData from "../../../data/community";
import "./Listing.scss";

class PostListing extends React.Component {
  render() {
    const { community } = this.props;
    // const itemList = community ? communityData : productData;
    let content = (
      <div>
          <div className="full-iframe">
              <iframe src="/pages/tdh/index.html"></iframe>
          </div>
          <div className="full-iframe">
              <iframe src="/pages/tdah/index.html"></iframe>
          </div>

      </div>
    );

    if (community) {
        content = (
            <div className="full-iframe">
                <iframe src="/pages/bhh/index.html"></iframe>
            </div>
        );
    }
    // if (itemList.length > 0) {
    //   content = (
    //     <div className="md-grid md-cell--12 mobile-fix">
    //       {itemList.map(item => <Preview key={item.name} item={item} />)}
    //     </div>
    //   );
    // }
    return content;
  }
}

export default PostListing;



// WEBPACK FOOTER //
// ./src/components/Listing/Listing.jsx